module.exports = __webpack_public_path__ + "img/f1blue.6d6355c8.png";